// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2kS_n","paginationItem":"_30RLy","paginationItemBtn":"_1p0kG","active":"_3X5ew","prevBtn":"_3_yxV","nextBtn":"_1G_ba"};